/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_ShareInputs */

const cs_documents_share = /** @type {(inputs: Documents_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sdílet`)
};

const en_documents_share = /** @type {(inputs: Documents_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share`)
};

/**
* | output |
* | --- |
* | "Share" |
*
* @param {Documents_ShareInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_share = /** @type {((inputs?: Documents_ShareInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_ShareInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_share(inputs)
	return cs_documents_share(inputs)
});